import React from 'react';
import { CheckCircle2Icon, CreditCardIcon, ShieldIcon, ZapIcon } from 'lucide-react';
import { CHECKOUT_URL, CTAButton, INSTAGRAM_LINK, PRICE, PRICE_SHORT, Section, SUPPORT_EMAIL, WHATSAPP_LINK } from './Shared';
export function EmotionalClose() {
  return <Section className="max-w-4xl" data-id="element-32" data-mp="qn9uo5neu6dw">
      <div className="relative overflow-hidden rounded-3xl border border-brand-gold/45 bg-white p-6 text-center shadow-lg md:p-12" data-id="element-33" data-mp="qm8i1wqqxbu2">
        <div aria-hidden="true" className="absolute left-0 top-0 h-28 w-28 rounded-br-full bg-brand-purpleMist" data-id="element-34" data-mp="mjlj7bvnqqnd" />
        <div aria-hidden="true" className="absolute bottom-0 right-0 h-28 w-28 rounded-tl-full bg-brand-goldLight/60" data-id="element-35" data-mp="hoy2hz6wb0jc" />
        <div className="relative" data-id="element-36" data-mp="7onqghwljz5r">
          <h2 className="mb-8 font-display text-3xl font-bold leading-tight text-brand-purpleDark md:text-4xl" data-id="element-37" data-mp="7ppctij2c82s">
            Hay dos versiones de vos en este momento.
          </h2>
          <div className="mx-auto mb-10 max-w-2xl space-y-5 text-base leading-relaxed text-brand-text md:text-lg" data-id="element-38" data-mp="2226vsdwvcm1m">
            <p data-id="element-39" data-mp="351pweecyminl">
              Una que cierra esta página y la próxima sesión sigue sin saber exactamente qué protocolo usar, cómo
              diagnosticar el estado energético del paciente, cómo proteger su propio campo y cómo cobrar lo que
              realmente vale su trabajo.
            </p>
            <p className="font-semibold text-brand-purple" data-id="element-40" data-mp="3047jkcvtnjab">
              Y otra que decide que hoy es el día en que su práctica de Gemoterapia cambia para siempre.
            </p>
            <p className="font-serif text-lg italic text-brand-goldDark md:text-xl" data-id="element-41" data-mp="3ssd7f8i69oed">
              La pregunta no es si podés pagarlo.
              <br data-id="element-42" data-mp="3e2xhtvudnp09" />
              La pregunta es cuántas sesiones más vas a trabajar sin un sistema energético que te respalde.
            </p>
          </div>

          <div className="mx-auto mb-10 max-w-md rounded-2xl border-2 border-brand-gold/60 bg-white p-6 shadow-[0_10px_30px_rgba(42,18,89,.14)]" data-id="element-43" data-mp="am8juy8v1nm7">
            <span className="relative -top-9 rounded-full bg-brand-purple px-3 py-1 text-xs font-bold text-brand-goldLight" data-id="element-44" data-mp="ffa31ig3o9bl">
              ⭐ MÁS ELEGIDO
            </span>
            <h3 className="-mt-4 font-serif text-xl font-bold text-brand-purpleDark" data-id="element-45" data-mp="kbe5i1abtq16">
              🏆 MEGA PACK MAESTRO DE GEMOTERAPIA™
            </h3>
            <p className="my-2 text-4xl font-bold text-brand-purple" data-id="element-46" data-mp="b9ejsvod9xrw">{PRICE}</p>
            <p className="mb-5 text-sm leading-relaxed text-brand-muted" data-id="element-47" data-mp="bbirzptatixz">
              4 Tomos + 5 Bonus · Más de 160 páginas. El sistema integral de protocolos, cristales, chakras, protección
              energética, seguimiento del paciente y posicionamiento profesional.
            </p>
            <CTAButton href={CHECKOUT_URL} fullWidth className="text-sm md:text-base" data-id="element-48" data-mp="3sntj96s30qa9">
              🏆 → QUIERO MI MEGA PACK {PRICE_SHORT}
            </CTAButton>
          </div>

          <div className="mb-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-brand-muted md:text-sm" data-id="element-49" data-mp="3jool41kfmyym">
            <span className="flex items-center" data-id="element-50" data-mp="3es7xd8h5amm2">
              <CheckCircle2Icon className="mr-1.5 h-4 w-4" data-id="element-51" data-mp="1u8vqaatjcfl8" />
              Pago 100% seguro
            </span>
            <span className="flex items-center" data-id="element-52" data-mp="1z64bkk9zczqp">
              <ZapIcon className="mr-1.5 h-4 w-4" data-id="element-53" data-mp="1z908q6e07ke3" />
              Acceso en 5 minutos
            </span>
            <span className="flex items-center" data-id="element-54" data-mp="244fhijx5mq3n">
              <ShieldIcon className="mr-1.5 h-4 w-4" data-id="element-55" data-mp="286tzz2wwvnue" />
              Garantía 7 días
            </span>
            <span className="flex items-center" data-id="element-56" data-mp="1biw4pxwwlimk">
              <CreditCardIcon className="mr-1.5 h-4 w-4" data-id="element-57" data-mp="1ggpc2u9y0iof" />
              Mercado Pago y Tarjeta
            </span>
          </div>

          <div className="rounded-2xl border border-brand-purple/15 bg-brand-surfaceLight p-5 text-left text-sm leading-relaxed text-brand-text md:p-6 md:text-center" data-id="element-58" data-mp="1ki11ozsth3wm">
            <p data-id="element-59" data-mp="sr3bc2dx9veb">
              <strong className="text-brand-purpleDark" data-id="element-60" data-mp="srmv7on4utuz">P.D.:</strong> Si tenés dudas, escribinos a{' '}
              <a className="font-semibold text-brand-purple hover:underline" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-61" data-mp="ws6v2zz3cbkt">
                {SUPPORT_EMAIL}
              </a>{' '}
              o por{' '}
              <a className="font-semibold text-brand-purple hover:underline" href={WHATSAPP_LINK} data-id="element-62" data-mp="8pile7jvg9a2">
                WhatsApp
              </a>
              . También podés encontrarnos en Instagram como{' '}
              <a className="font-semibold text-brand-purple hover:underline" href={INSTAGRAM_LINK} data-id="element-63" data-mp="imn1bpn4j8if">
                @lumen.akasha
              </a>
              . Te respondemos hoy.
            </p>
            <p className="mt-3 italic text-brand-goldDark" data-id="element-64" data-mp="rg02fevcdgfl">
              El precio de lanzamiento sube pronto. El mejor momento para tener tu sistema profesional de Gemoterapia es
              ahora.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}